import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { EventsService, UtilService, VariablesService, VwoService } from '../../../../shared/services';
import { IFundraiser } from '../../../../fundraiser/models/fundraiser.model';

@Component({
  selector: 'app-banner',
  templateUrl: './banner.component.html',
  styleUrls: ['./banner.component.scss']
})
export class BannerComponent implements OnInit {

  @Input() public fundraiser: IFundraiser;
  @Input() public theaterImg;
  @Input() public isFundraiserEnded;
  @Output() public watchVideo = new EventEmitter();
  isMobile: any;
  today = new Date();
  constructor(
    public utilService: UtilService,
    public vwo: VwoService,
    public varService: VariablesService,
    private events: EventsService
  ) { }
  userData;

  ngOnInit() {
    this.isMobile = this.utilService.isMobile();
    this.varService.userData.subscribe(val => {
      this.userData = val;
    })
  }

  /**Scroll to appealing video section */
  scrollToVideo() {
    this.watchVideo.emit(true);
  }

  toggleBlur() {
    this.varService.blur_image = !this.varService.blur_image;
    const ePayload = {
      eventName: 'story_blur_images',
      info_1: this.varService.blur_image ? "ON" : "OFF"
    }; 
    this.events.sendSystemEvent(ePayload).subscribe(_ => _);
  }

  getTheaterImage() {
    if (this.fundraiser && this.fundraiser.gallery) {
      return this.fundraiser?.gallery[0]?.cdn_path;
    }
    return this.utilService.defaultImg;
  }

}
